<template>
    <md-toolbar class="md-transparent">
        <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
                <h3 class="md-title" v-text="titlePage"></h3>
            </div>
            <div class="md-toolbar-section-end">
                <span class="user-full-name" v-text="userFullName"></span>
                <drop-down direction="down">
                    <md-button slot="title" class="md-just-icon md-simple" data-toggle="dropdown">
                        <md-icon>person</md-icon>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                        <li>
                            <router-link to="/security">Security</router-link>
                        </li>
                        <li class="divider"></li>
                        <li>
                            <a @click="actionLogout">Logout</a>
                        </li>
                    </ul>
                </drop-down>
                <md-button class="md-just-icon md-round md-simple md-toolbar-toggle"
                           :class="{ toggled: $sidebar.showSidebar }" @click="toggleSidebar">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </md-button>
            </div>
        </div>
    </md-toolbar>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Toolbar",
        computed: {
            user() {
                return this.authenticatedInitData.user ?? {};
            },
            userFirstName() {
                return this.user.firstName ?? '';
            },
            userLastName() {
                return this.user.lastName ?? '';
            },
            userFullName() {
                return this.userFirstName + ' ' + this.userLastName;
            },
            ...mapGetters('app', {
                titlePage: 'getTitlePage',
                authenticatedInitData: 'getAuthenticatedInitData',
            })
        },
        methods: {
            actionLogout() {
                this.$bus.emit('logout')
            },
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            },
        }
    }
</script>

<style lang="scss" scoped>
    li a {
        cursor: pointer;
    }

    .md-toolbar {
        z-index: 1 !important;
    }

    .user-full-name {
        margin-right: 6px;
        font-size: 16px;
    }
</style>